import { PDFDocument } from 'pdf-lib';
import html2canvas from 'html2canvas';

export default {
  name: 'pdfService',
  methods: {
    async convertHtmlToBase64(element, fitToLetter) {
      try {
        const canvas = await html2canvas(element);
        const dataUrl = canvas.toDataURL('image/png');

        const pdfDoc = await PDFDocument.create();
        const pageDimensions = fitToLetter
          ? [612, 792]
          : [canvas.width, canvas.height];
        const page = pdfDoc.addPage(pageDimensions);

        const pngImage = await pdfDoc.embedPng(dataUrl);
        const { width, height } = pngImage.scale(1);

        // Scale factor used if `fitToLetter` is true
        const scaleFactor = Math.min(
          page.getWidth() / width,
          page.getHeight() / height,
        );

        // Calculate the position to center the image - used if `fitToLetter` is true
        const xOffset = (page.getWidth() - width * scaleFactor) / 2;
        const yOffset = (page.getHeight() - height * scaleFactor) / 2;

        // Positioning the image on the PDF depends on `fitToLetter`
        const drawImageOptions = fitToLetter
          ? {
            x: xOffset,
            y: yOffset,
            width: width * scaleFactor,
            height: height * scaleFactor,
          }
          : {
            x: 0,
            y: page.getHeight() - height,
            width,
            height,
          };

        page.drawImage(pngImage, drawImageOptions);

        const pdfBytes = await pdfDoc.saveAsBase64({ dataUri: true });
        const base64String = pdfBytes.split(',')[1];

        return base64String;
      } catch (error) {
        console.error('Error converting HTML to PDF:', error);
        throw error;
      }
    },
  },
};
